export default __webpack_public_path__ + "static/media/579.9679c515.gif";